import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { Table } from "../../../../../../Shared/Table/Table";
import { SectionHeader } from "../../../Common/SharedComponents";

interface IDocumentsProps {
    data: any;
}

interface IDocumentsState {}

export class Documents extends FormComponent<IDocumentsProps, IDocumentsState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <>
                {SectionHeader("Documents")}
                <div>
                    <Table
                        data={[{ FileName: "SIPP illustration" }]}
                        col={[
                            {
                                title: "File name",
                                key: "FileName",
                                render: (data) => {
                                    return <a className="hyperlink">{data}</a>;
                                },
                            },

                            {
                                title: "Generate",
                                key: "",
                                render: () => {
                                    return (
                                        <button type="button" className="download-button" onClick={() => {}}>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                    );
                                },
                            },
                        ]}
                    />
                </div>
            </>
        );
    }
}
